export enum UserRole {
  consigliore = "Consigliore",
  caporegime = "Caporegime",
  soldato = "Soldato",
  mudlet = "Mudlet",
}
